import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { FirestoreService } from "../../../../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../../../api/firebase/references";
import { ToastMessages } from "../../../../../components/toasts/toastMessages";

interface HandleRejectNarIngestionParams {
  documentId: string;
  setIsSubmitting?: (isSubmitting: boolean) => void;
}

export const handleRejectNarIngestion = async ({
  documentId,
  setIsSubmitting,
}: HandleRejectNarIngestionParams) => {
  try {
    if (setIsSubmitting) {
      setIsSubmitting(true);
    }

    await FirestoreService.updateDocument(
      FirestoreCollectionReference.narIngestionLogs(),
      documentId,
      {
        is_rejected: true,
      },
    );
    toast.success(ToastMessages.NAR_INGESTION_REJECTED_SUCCESS);

    if (setIsSubmitting) {
      setIsSubmitting(false);
    }
  } catch (error) {
    toast.error(ToastMessages.NAR_INGESTION_REJECTED_FAILURE);
    if (setIsSubmitting) {
      setIsSubmitting(false);
    }
  }
};
